var _rect, _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#FDFBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -120,0 A 120,120 0 0 1 120,0 L 100,0 A 100,100 0 0 0 -100,0 Z",
    fill: "#DDA48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -100,0 A 100,100 0 0 1 100,0 L 80,0 A 80,80 0 0 0 -80,0 Z",
    fill: "#9CBA8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -80,0 A 80,80 0 0 1 80,0 L 60,0 A 60,60 0 0 0 -60,0 Z",
    fill: "#E4C5A1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -90,20 Q 0,60 90,20 L 85,30 Q 0,70 -85,30 Z",
    fill: "#C69C6D",
    stroke: "#B17E51",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -60,
    width: 60,
    height: 80,
    rx: 10,
    fill: "#DDA48D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: -20,
    r: 10,
    fill: "#B17E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20,-60 Q 40,-80 60,-60 Q 50,-40 20,-40 Z",
    fill: "#DDA48D",
    stroke: "#B17E51",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 20,
    x2: -50,
    y2: 40,
    stroke: "#B17E51",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20,
    x2: 50,
    y2: 40,
    stroke: "#B17E51",
    strokeWidth: 6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 550,
    fontFamily: "sans-serif",
    fontSize: 30,
    fill: "#4A7B59",
    textAnchor: "middle"
  }, "\r\n    GAN SECOND HOME\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.b5384d77055007bdbd8fdff24899acec.svg";
export { ForwardRef as ReactComponent };